module.exports = __webpack_public_path__ + "static/img/logo-movida.18453a4a.svg";